import { getConfig } from '../../config';

const config = getConfig();

export const paths = [
  {
    label: 'Parties',
    icon: 'fas fa-glass-cheers',
    type: 'icon',
    path: '/parties',
    children: [],
  },
  {
    label: 'Users',
    icon: 'fas fa-user',
    type: 'icon',
    path: '/users',
    children: [],
  },
  {
    label: 'Marketplace',
    icon: 'fas fa-beer',
    type: 'icon',
    children: [
      {
        label: 'Experiences',
        path: '/activities',
      },
      {
        label: 'FareHarbor Items',
        path: '/fareharbor',
      },
      {
        label: 'Experience Tags',
        path: '/tags',
      },
      {
        label: 'Ratings & Reviews',
        path: '/rnrs',
      },
      {
        label: 'Vendors',
        path: `${config.batchAdminURL}/partners`,
        external: true,
      },
      {
        label: 'Orders',
        path: '/orders',
      },
      {
        label: 'Promo Codes',
        path: '/promo',
      },
    ],
  },
  {
    label: 'City Guides',
    icon: 'fas fa-city',
    type: 'icon',
    children: [
      {
        label: 'Cities',
        path: `${config.batchAdminURL}/cities`,
        external: true,
      },
      {
        label: 'In a Nutshell',
        path: '/entertainments',
      },
      {
        label: 'Out of Market Explore Config',
        path: '/exploreConfig',
      },
    ],
  },
];
